import { useMemo, useState } from 'react'
import { Copy, Check } from '@phosphor-icons/react'
import { Button } from '../../../../Components/Screen/Button/button'
import { Subtext } from '../../../../Components/Screen/Text/Body'

const POLYGONSCAN_TX = 'https://polygonscan.com/tx/'

function generateTxHash() {
  const bytes = new Uint8Array(32)
  if (typeof window !== 'undefined' && window.crypto?.getRandomValues) {
    window.crypto.getRandomValues(bytes)
  } else {
    for (let i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256)
  }
  return '0x' + Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')
}

export function BlockchainHash() {
  const hash = useMemo(generateTxHash, [])
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(hash)
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    } catch {
      // ignore
    }
  }

  return (
    <div className="flex flex-col items-center gap-3 w-full max-w-3xl">
      <div className="flex items-center gap-2 max-w-full">
        <Subtext className="text-branco truncate">
          <span className="text-cinza">Blockchain hash:</span> {hash}
        </Subtext>
        <button
          type="button"
          onClick={handleCopy}
          className="text-cinza hover:text-branco transition shrink-0"
          title="Copiar hash"
        >
          {copied ? <Check size={18} className="text-verdeClaro" /> : <Copy size={18} />}
        </button>
      </div>
      <Button
        as="a"
        href={`${POLYGONSCAN_TX}${hash}`}
        target="_blank"
        rel="noreferrer"
        className="!rounded-full !bg-azulClaro hover:!bg-azulClaro/80 !text-white"
      >
        <span className="text-white">Acessar transação</span>
      </Button>
    </div>
  )
}
